import React, { useState, useEffect } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { linter, lintGutter } from "@codemirror/lint";
import { JSHINT } from "jshint";

const JavaScriptCodeEditorTerminal = () => {
  const [code, setCode] = useState("");
  const [output, setOutput] = useState("");

  // 🔹 get ?code=... from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const initialCode = params.get("code") || "console.log('Hello World');";
    setCode(decodeURIComponent(initialCode));
  }, []);

  const runCode = () => {
    try {
      let logs = [];
      const originalLog = console.log;
      console.log = (...args) => logs.push(args.join(" "));

      // eslint-disable-next-line no-eval
      eval(code);

      console.log = originalLog;
      setOutput(logs.join("\n"));
    } catch (err) {
      setOutput(err.message);
    }
  };

  const jsHintLinter = linter((view) => {
    JSHINT(view.state.doc.toString(), {
      esversion: 6,
      undef: true,
      predef: ["console"],
    });

    return JSHINT.errors.map((err) => ({
      from: err.character - 1,
      to: err.character,
      severity: err.code?.startsWith("W") ? "warning" : "error",
      message: err.reason,
    }));
  });

  return (
    <div style={{ display: "flex", width: "100%" }}>
      {/* Editor Panel */}
      <div style={{ flex: 1, position: "relative", width: "50%" }}>
        <button
          onClick={runCode}
          style={{
            position: "absolute",
            top: "10px",
            right: "30px",
            zIndex: 10,
            padding: "10px 20px",
            background: "#333",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Run ▶
        </button>
        <CodeMirror
          value={code}
          height="82vh"
          extensions={[javascript(), lintGutter(), jsHintLinter]}
          onChange={(value) => setCode(value)}
        />
      </div>

      {/* Output Panel */}
      <div
        style={{
          flex: 1,
          background: "#1e1e1e",
          color: "#d4d4d4",
          padding: "10px",
          borderRadius: "5px",
          width: "50%",
          overflowX: "auto",
          height: "82vh",
          whiteSpace: "pre-wrap",
        }}
      >
        <h4>Output:</h4>
        <pre>{output}</pre>
      </div>
    </div>
  );
};

export default JavaScriptCodeEditorTerminal;
